module.exports = __webpack_public_path__ + "static/media/dela.fc77842a.mp3";